var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.$route.query.v === '2' ? _c('bank-lookup-section-embed-v2', {
    attrs: {
      "history": _vm.history,
      "query": _vm.query,
      "result": _vm.result,
      "on-redirect": _vm.onRedirect,
      "dark": _vm.$route.query.dark === '1'
    },
    on: {
      "update:history": function ($event) {
        _vm.history = $event;
      },
      "update:query": function ($event) {
        _vm.query = $event;
      },
      "update:result": function ($event) {
        _vm.result = $event;
      }
    }
  }) : _c('bank-lookup-section-embed', {
    attrs: {
      "history": _vm.history,
      "query": _vm.query,
      "result": _vm.result,
      "on-redirect": _vm.onRedirect
    },
    on: {
      "update:history": function ($event) {
        _vm.history = $event;
      },
      "update:query": function ($event) {
        _vm.query = $event;
      },
      "update:result": function ($event) {
        _vm.result = $event;
      }
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };